<template>
  <ManageRegionsTemplateForm
    v-if="data"
    :data="data"
    :hasType="false"
    isHme
    :regionsEndPoint="regionsEndPoint"
    :textData="textData"
    :validationData="validationData"
  />
</template>

<script setup>
import { computed } from 'vue';

// Utils
import I18n from 'i18n-js';
import { useShaftV2Hme } from '@/functions/use_remote_object';

// Components
import ManageRegionsTemplateForm from '@/components/form/hme_manage_regions_template.vue';

const props = defineProps({
  organisationId: { type: String, required: true },
  shaftId: { type: String, required: true },
  heavyMobileEquipmentId: { type: String, required: false, default: '' },
});

const data = useShaftV2Hme(props);

const regionsEndPoint = computed(() => {
  return `/organisations/${props.organisationId}/shafts_v2/shafts/${props.shaftId}/heavy_mobile_equipments/${props.heavyMobileEquipmentId}/heavy_mobile_equipment_regions`;
});

const validationData = {
  operation: 'heavy_mobile_equipment',
  operation_region: 'heavy_mobile_equipment_region',
  operation_regions: 'heavy_mobile_equipment_regions',
};

const textData = {
  pending_tile_process: {
    title: I18n.t('shafts.group.heavy_mobile_equipment.diagram_loading_title'),
    description: I18n.t('shafts.group.heavy_mobile_equipment.diagram_loading_description'),
  },
  no_diagram: {
    title: I18n.t('shafts.group.heavy_mobile_equipment.no_hme_diagram.title'),
    description: I18n.t('shafts.group.heavy_mobile_equipment.no_hme_diagram.message'),
  },
};
</script>
<style scoped lang="scss">
@import '@/stylesheets/global';
.current-item-name {
  margin: bu(1.8) bu(2);
}
</style>
